import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { LoadingState } from "../components/LoadingState";

export function DashboardGuard() {
  const { session, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="fullscreen-status"><LoadingState label="Opening dashboard" /></div>;
  if (!session) return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  return <Outlet />;
}
